module.exports = __webpack_public_path__ + "static/media/decoline-large.70b0d4e7.svg";